import * as ACTION from './constants';

const initialState = {
  isLoading: false,
  resourceData: null,
}

export default function reducers(state = initialState, action) {
  switch(action.type) {
    case ACTION.RESOURCE_BASE:
      return {...initialState}
    case ACTION.RESOURCE_LOADING:
      return {...state,
        isLoading: true,
      }
    case ACTION.RESOURCE_SUCCESS:
      return {...state,
        isLoading: false,
        resourceData: action.payload,
      }
    default:
      return state
  }
}
